export default "__VITE_ASSET__eKTAvu1R__"